import {WidgetSettings} from "src/interfaces/settings";
import HeaderBackBtn from "./ui/HeaderBackBtn";
import SearchBtn from "./ui/SearchBtn";
import {Button} from "../ui/button";
import Icon from "../Icon";
import {t} from "i18next";
import {useState} from "react";

interface Props {
  widgetSettings: WidgetSettings;
  languageCode: string;
  showTitle?: boolean;
  showSearch?: boolean;
  showAssistantChat?: boolean;
  showBackButton?: boolean;
  closeButton?: React.ReactNode;

  onAssistantChatButtonClick?: () => void;
  onBackButtonClick: () => void;
  onSearchButtonClick: () => void;
}

export default function Header({
  widgetSettings,
  languageCode,
  showTitle,
  onBackButtonClick,
  onSearchButtonClick,
  showSearch,
  closeButton,
  showAssistantChat,
  onAssistantChatButtonClick,
  showBackButton = true,
}: Props) {
  const [showAssistantChatHighlight, setShowAssistantChatHighlight] = useState(true);

  return (
    <header className="faq-widget-header">
      {showTitle && <h1>{widgetSettings.langs?.[languageCode]?.title || "Customer Service"}</h1>}
      {showBackButton && (
        <HeaderBackBtn
          handleBackButtonClick={onBackButtonClick}
          text={widgetSettings.langs?.[languageCode]?.backButtonText}
        />
      )}
      <div className="faq-widget-header-right">
        {showSearch && (
          <SearchBtn
            title={widgetSettings.langs?.[languageCode]?.searchButtonText}
            ariaLabel={widgetSettings.langs?.[languageCode]?.searchButtonText}
            handleSearchButtonClick={onSearchButtonClick}
            buttonColor={widgetSettings?.categoryButtonColor}
            text={widgetSettings.langs?.[languageCode]?.searchButtonText}
          />
        )}
        {showAssistantChat && (
          <div className="relative">
            <Button
              onClick={onAssistantChatButtonClick}
              title={widgetSettings.langs?.[languageCode]?.assistantButtonText}
              aria-label={widgetSettings.langs?.[languageCode]?.assistantButtonText}
              className="rounded-full bg-[#242321] text-white flex items-center gap-1"
              style={{
                backgroundColor: widgetSettings?.buttonColor,
              }}
            >
              <Icon name="zap" iconSize="20px" />
              {widgetSettings.langs?.[languageCode]?.assistantButtonText || t("ASSISTANT")}
            </Button>
            {widgetSettings.assistantChatHighlightEnabled &&
              widgetSettings.langs?.[languageCode]?.assistantChatHighlightText &&
              showAssistantChatHighlight && (
                <div className="absolute top-11 -left-8 bg-white border rounded-lg p-2">
                  <div className="flex justify-between">
                    <span className="text-sm font-bold bg-amber-200  px-2 py-1 rounded-full">{t("NEW")}!</span>
                    <button
                      className="absolute top-1 right-1 p-1 border rounded-full h-6 w-6 flex items-center justify-center"
                      onClick={() => setShowAssistantChatHighlight(false)}
                    >
                      <Icon name="close" iconSize="16px" />
                    </button>
                  </div>
                  <span className="absolute -top-2 left-1/2 -translate-x-1/2 bg-white w-4 h-4 border-l border-t rotate-45"></span>
                  <p>{widgetSettings.langs?.[languageCode]?.assistantChatHighlightText}</p>
                </div>
              )}
          </div>
        )}
        {closeButton}
      </div>
    </header>
  );
}
